<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <user-role-edit-form
        @on-submit="onUserRoleEditSubmit"
      ></user-role-edit-form>
    </div>
  </div>
</template>
<script>
import UserRoleEditForm from "./UserRoleEditForm.vue";

export default {
  components: {
    UserRoleEditForm
  },
  data() {
    return {
      userRoleEditModel: {}
    };
  },
  methods: {
    onUserRoleEditSubmit(model) {
      this.userRoleEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'users/' + this.userEditModel.id, Object.assign(this.userEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
